import Axios from 'axios';
import AuthApi from "@/services/api/auth";
import LeadsApi from "@/services/api/leads";
import CompanyApi from "@/services/api/company";
import FeedbackApi from "@/services/api/feedback";
import InvoicesApi from "@/services/api/invoices";
import NotificationApi from "@/services/api/notifications";
import ContactApi from "@/services/api/contact";
import PaymentsApi from "@/services/api/payments"
import CoverageApi from "@/services/api/coverage";
import CoverageRegionApi from "@/services/api/coverage-region";
import WorkTypesApi from "@/services/api/worktypes";
import LocationsApi from "@/services/api/locations";
import PageApi from "@/services/api/page";
import AddressApi from "@/services/api/address";
import VerificationApi from "@/services/api/verification";
import RegistrationJourneyAPI from "@/services/api/registration-journey";
import AppApi from "@/services/api/app";
import TodosApi from "@/services/api/todos";
import BusinessUnitContactDetailsApi from "@/services/api/business-unit-contact-details";
import CountryApi from "@/services/api/country";
import LeadSendTokenApi from "@/services/api/lead-send-token";

const API_URL = process.env.VUE_APP_API_URL;
const VERSION = 'v1';
// eslint-disable-next-line new-cap
const client = new Axios.create({
  baseURL: API_URL,
  withCredentials: true
});

// eslint-disable-next-line new-cap
const localFileSystemClient = new Axios.create({
  withCredentials: true
});

let Api = {
  auth: new AuthApi(client, {
    version: VERSION,
  }),
  leads: new LeadsApi(client, {
    version: VERSION,
  }),
  company: new CompanyApi(client, {
    version: VERSION,
  }),
  feedback: new FeedbackApi(client, {
    version: VERSION,
  }),
  notification: new NotificationApi(client, {
    version: VERSION,
  }),
  invoices: new InvoicesApi(client, {
    version: VERSION,
  }),
  payments: new PaymentsApi(client, {
    version: VERSION,
  }),
  contact: new ContactApi(client, {
    version: VERSION,
  }),
  coverage: new CoverageApi(client, {
    version: VERSION,
  }),
  coverageRegion: new CoverageRegionApi(client, {
    version: VERSION,
  }),
  workTypes: new WorkTypesApi(client, {
    version: VERSION,
  }),
  locations: new LocationsApi(client, {
    version: VERSION,
  }),
  address: new AddressApi(client, {
    version: VERSION,
  }),
  verification: new VerificationApi(client, {
    version: VERSION,
  }),
  page: new PageApi(localFileSystemClient, {
    version: VERSION,
  }),
  registrationJourney: new RegistrationJourneyAPI(client, {
    version: VERSION,
  }),
  app: new AppApi(client, {
    version: VERSION,
  }),
  todos: new TodosApi(client, {
    version: VERSION,
  }),
  businessUnitContactDetails: new BusinessUnitContactDetailsApi(client, {
    version: VERSION,
  }),
  country: new CountryApi(client, {
    version: VERSION,
  }),
  leadSendToken: new LeadSendTokenApi(client, {
    version: VERSION,
  }),
};

export {Api};
